import { render, staticRenderFns } from "./SlideImagesPopup.vue?vue&type=template&id=4e8cd488&scoped=true&"
import script from "./SlideImagesPopup.vue?vue&type=script&lang=js&"
export * from "./SlideImagesPopup.vue?vue&type=script&lang=js&"
import style0 from "./SlideImagesPopup.vue?vue&type=style&index=0&id=4e8cd488&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8cd488",
  null
  
)

export default component.exports